import request from '@/utils/request'

// 加载表格数据
export function getShopList(params){
    return request({
        url: '/server/shop/select',
        method: 'get',
        params: params
    })
}
// 加载表格数据
export function getLazada(params){
    return request({
        url: '/server/shop/select',
        method: 'get',
        params: params
    })
}

// 加载表格数据
export function getLazadaCategory(shopId){
    return request({
        url: '/server/shop/getLazadaCategory/' + shopId,
        method: 'get',
    })
}

// 加载表格数据
export function syncLazada(data){
    return request({
        url: '/server/universal/template/syncLazada',
        method: 'post',
        data: data
    })
}


// 加载表格数据
export function getChannelList(data){
    return request({
        url: '/server/order/channelList',
        method: 'GET',
        params: data
    })
}


// 加载表格数据
export function syncShopee(data){
    return request({
        url: '/server/universal/template/syncShopee',
        method: 'post',
        data: data
    })
}


// 加载表格数据
export function syncTiktok(data){
    return request({
        url: '/server/universal/template/syncTiktok',
        method: 'post',
        data: data
    })
}


// 加载表格数据
export function getCategoryAttribute(data){
    return request({
        url: '/server/lazada/product/getCategoryAttribute',
        method: 'get',
        params: data
    })
}



// 加载表格数据
export function getBrandByPages(data){
    return request({
        url: '/server/lazada/product/getBrandByPages',
        method: 'get',
        params: data
    })
}



export function templateTiming(data) {
    return request({
      url: "/server/universal/template/timing",
      method: "post",
      data: data
    })
  }

export function getShopSiteList(data) {
    return request({
      url: "/product/shienApi/getShopSiteList",
      method: "get",
      params: data
    })
  }

  // 发布shein产品
export function sendProduct(data) {
    return request({
      url: "/product/shienApi/sendProduct",
      method: "post",
      data: data,
    })
  }
  // 保存shein产品
export function setProduct(data) {
    return request({
      url: "/product/shienApi/setProduct",
      method: "post",
      data: data,
    })
  }
  // 获取shein产品列表
export function getProductList(data) {
    return request({
      url: "/product/shienApi/list",
      method: "get",
      params: data,
    })
  }
  // 获取shein产品详情
export function getProductDetail(data) {
    return request({
      url: "/product/shienApi/"+data.pId,
      method: "get",
    //   params: data,
    })
  }
    // 批量删除shein产品
export function removeSheinProduct(data) {
  return request({
    url: "/product/shienApi/remove",
    method: "post",
    data: data,
  })
}
    // 定时发布shein产品
export function timingSheinProduct(data) {
  return request({
    url: "/product/shienApi/timing",
    method: "post",
    data: data,
  })
}
    // 取消shein定时发布
export function cancelTiming(data) {
  return request({
    url: "/product/shienApi/cancelTiming",
    method: "post",
    data: data,
  })
}
    // 获取全量耗材类型和耗材材质信息（废弃）
export function getMaterialQualityTreeFromDb(data) {
  return request({
    url: "/product/shienApi/getMaterialQualityTreeFromDb",
    method: "get",
    params: data,
  })
}
    // 获取全量环保耗材信息（新）
export function getMaterialQualityTreeV2(data) {
  return request({
    url: "/product/shienApi/getMaterialQualityTreeV2",
    method: "get",
    params: data,
  })
}
    // 获取环保标配置规则
export function getEnvironmentalLabelRule(data) {
  return request({
    url: "/product/shienApi/getEnvironmentalLabelRule",
    method: "post",
    data: data,
  })
}
    // 打印环保标
export function getEnvironmentalLabelRulePrint(data) {
  return request({
    url: "/product/shienApi/getEnvironmentalLabelRulePrint",
    method: "post",
    data: data,
  })
}
    // 打印商品条码
export function getPrintBarcode(data) {
  return request({
    url: "/product/shienApi/getPrintBarcode",
    method: "post",
    data: data,
  })
}
    // 打印面单
export function getPrintPackage(data) {
  return request({
    url: "/product/shienApi/getPrintPackage",
    method: "get",
    params: data,
  })
}
    // 国内发货
export function getOrderToShipping(data) {
  return request({
    url: "/product/shienApi/getOrderToShipping",
    method: "post",
    data: data,
  })
}
    // 物流产品查询
export function getExpressCompanyListV2(data) {
  return request({
    url: "/product/shienApi/getExpressCompanyListV2",
    method: "post",
    data: data,
  })
}
    // 发货基本信息查询
export function getBasicShipInfoByAny(data) {
  return request({
    url: "/product/shienApi/getBasicShipInfoByAny",
    method: "get",
    params: data,
  })
}
    // 收货仓信息查询
export function getWarehouse(data) {
  return request({
    url: "/product/shienApi/getWarehouse",
    method: "get",
    params: data,
  })
}
    // 取消/修改发货单
export function getModifyDeliveryOrderInfo(data) {
  return request({
    url: "/product/shienApi/getModifyDeliveryOrderInfo",
    method: "post",
    data: data,
  })
}
    // shein半托-获取店铺可用物流
export function getSheinBtChannelList(data) {
  return request({
    url: "/product/shienApi/getHandleExpressChannel",
    method: "get",
    params: data,
  })
}
    // shein半托-上传运单
export function exportBTWayBillNo(data) {
  return request({
    url: "/product/shienApi/exportBTWayBillNo",
    method: "post",
    data: data,
  })
}
    // shein半托-导出地址
export function exportBTaddr(data) {
  return request({
    url: "/product/shienApi/exportBTaddr",
    method: "post",
    data: data,
  })
}
    // shein半托-打印面单
export function getBTFacemarkinfoPdf(data) {
  return request({
    url: "/product/shienApi/getBTFacemarkinfoPdf",
    method: "post",
    data: data,
  })
}
    // shein半托-销售站点
export function getShopSiteBTList(data) {
  return request({
    url: "/product/shienApi/getShopSiteBTList",
    method: "get",
    params: data,
  })
}
    // shein半托-商家仓库
export function getWarehouseList(data) {
  return request({
    url: "/product/shienApi/getWarehouseList",
    method: "get",
    params: data,
  })
}
    // shein全托-预估运费
export function getPurchaseEstimatedFee(data) {
  return request({
    url: "/product/shienApi/getPurchaseEstimatedFee",
    method: "post",
    data: data,
  })
}
    // shein半托-发货仓库
export function warehouseAddressShein(data) {
  return request({
    url: "/product/shienApi/warehouseAddress",
    method: "get",
    params: data,
  })
}
    // shein半托-物流商（如果返回空则该仓库不支持在线下单）
export function expressChannelShein(data) {
  return request({
    url: "/product/shienApi/expressChannel",
    method: "post",
    data: data,
  })
}
    // shein半托-物流价格
export function orderMappingChannels(data) {
  return request({
    url: "/product/shienApi/orderMappingChannels",
    method: "post",
    data: data,
  })
}
    // shein半托-在线下单
export function shienOrderOnLine(data) {
  return request({
    url: "/product/shienApi/shienOrderOnLine",
    method: "post",
    data: data,
  })
}
    // shein半托-切换导出地址发货
export function switchSelfShipping(data) {
  return request({
    url: "/product/shienApi/switchSelfShipping",
    method: "post",
    data: data,
  })
}
// shein全托-更新发货地址
export function freshSAddress(data) {
  return request({
    url: "/product/shienApi/freshSAddress",
    method: "get",
    params: data,
  })
}